import React from "react";

interface JourneySegmentProps {
  duration: server.dto.DurationInSeconds;
  distance: server.dto.DistanceInMeters;
}

const SvgTop = ({ fillColor }: { fillColor: string }) => <svg xmlns="http://www.w3.org/2000/svg" width="13" height="35" viewBox="0 0 13 35" fill="none">
  <path fillRule="evenodd" clipRule="evenodd" d="M10.5 6C10.5 8.20914 8.70914 10 6.5 10C4.29086 10 2.5 8.20914 2.5 6C2.5 3.79086 4.29086 2 6.5 2C8.70914 2 10.5 3.79086 10.5 6ZM8 11.811C10.5878 11.1449 12.5 8.79576 12.5 6C12.5 2.68629 9.81371 0 6.5 0C3.18629 0 0.5 2.68629 0.5 6C0.5 8.79576 2.41216 11.1449 5 11.811V13H8V11.811ZM5 17V21H8V17H5ZM5 25L5 29H8L8 25H5ZM5 33V35H8V33L5 33Z" fill={fillColor} />
</svg>

const SvgBottom = ({ fillColor }: { fillColor: string }) => <svg xmlns="http://www.w3.org/2000/svg" width="13" height="34" viewBox="0 0 13 34" fill="none">
  <path fillRule="evenodd" clipRule="evenodd" d="M4.9996 0V2L7.9996 2V0H4.9996ZM4.9996 6V10H7.9996V6H4.9996ZM4.9996 14L4.9996 18H7.9996L7.9996 14H4.9996ZM7.9996 22H11.7622C12.517 22 12.9997 22.8042 12.6447 23.4703L7.38257 33.3441C7.00618 34.0503 5.99396 34.0503 5.61757 33.3441L0.355455 23.4703C0.000466688 22.8042 0.483167 22 1.23795 22H4.9996H7.9996ZM10.0961 24L6.50007 30.7476L2.90404 24H4.9996H7.9996H10.0961Z" fill={fillColor} />
</svg>

export const JourneySegment = ({ duration, distance }: JourneySegmentProps) => {
  if (!duration && !distance) return null;

  return <div className="flex-column justify-center align-center">
    <SvgTop fillColor="var(--blue)" />
    <div className="flex-column gap align-center margin-top-small margin-bottom-small">
      {duration && <span className="subtitle-text-regular">{duration.formatted}</span>}
      {distance && <span className="subtitle-text-regular">{distance.formatted}</span>}
    </div>
    <SvgBottom fillColor="var(--blue)" />
  </div>
};